import { FaBriefcase, FaUser } from "react-icons/fa";
import { IconContext } from "react-icons";
import { NavLink } from "react-router-dom";
import Tooltip from "../../../components/tooltip/Tooltip";
import "../Sidebar.css";
import { useMemo } from "react";

function ApplicantSideBar() {

  const value = useMemo(() => ({
    color: "gray",
    size: "40px",
  }), []);

  return (
    <nav className="sidebar" id="manager-sidebar">
      <IconContext.Provider
        value={value}
      >
        <div className="team-nav-group nav-group" id="step-sidebar">
            <div>
              <div>
                <Tooltip content="My Info" direction="right">
                  <NavLink
                    to="/profile/info"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FaUser />
                  </NavLink>
                </Tooltip>
              </div>
              <div>
                <Tooltip content="Jobs" direction="right">
                  <NavLink
                    to="/applicant/manage-jobs"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FaBriefcase />
                  </NavLink>
                </Tooltip>
              </div>
            </div>
        </div>

      </IconContext.Provider>
    </nav>
  );
}

export default ApplicantSideBar;
